module.exports = __webpack_public_path__ + "static/img/product-swipe43.925c84d0.png";